const BADGE = {
  0n: { label: '● 대기 중',      cls: 'ev-status-idle'   },
  1n: { label: '● 투표 진행 중', cls: 'ev-status-voting'  },
  2n: { label: '● 투표 종료',    cls: 'ev-status-ended'   },
};

function shortenAddress(addr) {
  return addr.slice(0, 6) + '...' + addr.slice(-4);
}

export default function Header({ electionState, walletAddress, isAdmin }) {
  const badge = BADGE[electionState] ?? BADGE[0n];
  return (
    <header className="ev-header">
      <div className="ev-header-title">세폴리아 투표 시스템</div>
      <div className="ev-header-right">
        <span className={`ev-status-badge ${badge.cls}`}>{badge.label}</span>
        {walletAddress && (
          <>
            <span className="ev-wallet-addr">{shortenAddress(walletAddress)}</span>
            {isAdmin && <span className="ev-admin-badge">관리자</span>}
          </>
        )}
      </div>
    </header>
  );
}
